import pergasClone from "./pergasClone";

export default function mapper() {
  const deepClone = pergasClone();
  const mappp = (inputOriginObject, inputTargetObject) => {
    let originObject = deepClone(inputOriginObject);
    let targetObject = deepClone(inputTargetObject);

    let isAllFieldsNull = true;

    for (let key in targetObject) {
      if (originObject.hasOwnProperty(key)) {
        const originValue = originObject[key];
        if (originValue === null) {
          targetObject[key] = null;
        } else if (!Array.isArray(originValue)) {
          if (typeof originValue !== "object") {
            targetObject[key] = originValue === "" ? null : originValue;
          } else {
            targetObject[key] = mappp(originValue, targetObject[key]);
          }
        } else {
          let mappedArray = [];
          for (let item of originValue) {
            if (typeof item === "object") {
              mappedArray.push(mappp(item, targetObject[key][0]));
            } else {
              mappedArray.push(item);
            }
          }
          targetObject[key] = mappedArray.length === 0 ? null : mappedArray;
        }
        if (targetObject[key] !== null) isAllFieldsNull = false;
      }
    }
    return isAllFieldsNull ? null : targetObject;
  };

  const mapAndRemoveNullAttributes = (inputOriginObject, inputTargetObject) => {
    let originObject = deepClone(inputOriginObject);
    let targetObject = deepClone(inputTargetObject);
    let isAllFieldsNull = true;

    let result = new Object();

    for (let key in targetObject) {
      if (originObject.hasOwnProperty(key)) {
        const originValue = originObject[key];
        if (originValue === null) {
          targetObject[key] = null;
        } else if (!Array.isArray(originValue)) {
          if (typeof originValue !== "object") {
            targetObject[key] = originValue === "" ? null : originValue;
          } else {
            targetObject[key] = mapAndRemoveNullAttributes(originValue, targetObject[key]);
          }
        } else {
          let mappedArray = [];
          for (let item of originValue) {
            if (typeof item === "object") {
              const recursiveResult = mapAndRemoveNullAttributes(item, targetObject[key][0]);
              if (recursiveResult !== null) mappedArray.push(recursiveResult);
            } else {
              if (item !== null) mappedArray.push(item);
            }
          }
          targetObject[key] = mappedArray.length === 0 ? null : mappedArray;
        }
        if (targetObject[key] !== null) {
          isAllFieldsNull = false;
          result[key] = targetObject[key];
        }
      } else {
        if (targetObject[key] !== null) result[key] = targetObject[key];
      }
    }
    return isAllFieldsNull ? null : result;
  };

  return [mappp, mapAndRemoveNullAttributes];
}
